"use client";

import React, { useState } from 'react';
import Sidebar from '../components/layout/Sidebar';
import SearchPrompt from '../components/ui/SearchPrompt';
import MobileNavigation from '../components/layout/MobileNavigation';
import MobileHeader from '../components/layout/MobileHeader';

export default function ExplorePage() {
  // State to control mobile sidebar
  const [mobileOpen, setMobileOpen] = useState(false);
  
  return (
    <main className="flex min-h-screen bg-gray-50">
      {/* Sidebar - Hidden on mobile, toggleable via drawer */}
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      
      {/* Mobile Header - Visible only on mobile */}
      <MobileHeader setMobileOpen={setMobileOpen} />
      
      <div className="flex-1 py-16 md:py-8 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">Explore Restaurants</h1>
          <p className="text-gray-600 mb-8">
            Discover new restaurants and cuisines in your area.
          </p>

          {/* Categories Section */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            {['Fast Food', 'Hi-Tea', 'Desi Food', 'Healthy'].map(category => (
              <div key={category} className="bg-white rounded-lg p-4 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                <h3 className="font-medium text-gray-800">{category}</h3>
              </div>
            ))}
          </div>

          {/* Popular Restaurants Section - Placeholder */}
          <h2 className="text-xl font-bold text-gray-800 mb-4">Popular Restaurants</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[1, 2, 3, 4].map(i => (
              <div key={i} className="bg-white rounded-lg p-4 shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex items-center">
                <div className="w-12 h-12 bg-gray-200 rounded-lg mr-4"></div>
                <div>
                  <h3 className="font-medium text-gray-800">Restaurant {i}</h3>
                  <p className="text-sm text-gray-500">Fast Food, Burgers</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* SearchPrompt component at the bottom */}
        <SearchPrompt />
      </div>
      
      {/* Mobile Bottom Navigation - Visible only on mobile */}
      <MobileNavigation />
    </main>
  );
} 